import { Entity } from "./Entity";

export class User extends Entity {
    public update(data: Map<any, any>) {
        this.updateData(data);
    }

    public getProfileData() {
        return this.getData();
    }
}
